interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i += 1) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "...") {
      pages.push("...");
    }
  }

  const btnBase =
    "flex items-center justify-center min-w-9 h-9 px-2.5 text-sm rounded-md border transition-colors cursor-pointer";

  return (
    <nav aria-label="分页导航" className="flex items-center justify-center flex-wrap gap-2 mt-8">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btnBase} border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="flex items-center justify-center w-4 h-4"><i className="ri-arrow-left-s-line" aria-hidden="true"></i></span>
        上一页
      </button>

      {pages.map((p, i) =>
        typeof p === "number" ? (
          <button
            key={i}
            type="button"
            onClick={() => onChange(p)}
            className={`${btnBase} ${
              p === current
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={i} className="flex items-center justify-center min-w-9 h-9 text-sm text-secondary-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${btnBase} border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        下一页
        <span className="flex items-center justify-center w-4 h-4"><i className="ri-arrow-right-s-line" aria-hidden="true"></i></span>
      </button>
    </nav>
  );
}